import type { LegalCitation } from '@buakei/types';
import { BookMarked } from 'lucide-react';
import { useInspector } from './inspector-context';

/** Every citation is clickable and opens the inspector (DESIGN-SYSTEM rule 1). */
export function CitationLink({ citation, index }: { citation: LegalCitation; index?: number }) {
  const { open } = useInspector();
  return (
    <button
      type="button"
      onClick={(event) => open(citation, event.currentTarget)}
      className="inline-flex items-center gap-1 rounded-sm text-left text-sm font-medium text-navy-900 underline decoration-navy-400 decoration-2 underline-offset-4 hover:decoration-navy-900"
      aria-label={`Inspect source: ${citation.label}`}
    >
      <BookMarked className="size-3.5 shrink-0" aria-hidden />
      {index !== undefined ? <span aria-hidden>[{index}]</span> : null}
      <span>{citation.label}</span>
    </button>
  );
}
